import {styled} from 'styled-components'

import FormPhoneInput, {PhoneInputUI} from '@/src/shared/ui/inputs/form-phone-input'
import {media} from '@/src/config/theme'

export const StyledPhoneInput = styled(FormPhoneInput)`
  & ${PhoneInputUI.Control} {
    border: 2px solid #bcbec0;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  
  & > .smart-captcha.smart-captcha_invisible {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
    color: transparent;
    background-color: transparent;
  }
`


export const LoginButton = styled.div`
  position: relative;
  cursor: pointer;

  height: 47px;
  padding: 8px 28px;

  width: 100%;

  display: flex;
  justify-content: center;

  border-width: 1px;
  border-color: #0000001f;
  border-style: solid;
  border-radius: 5px;

  @media ${media.sm} {
    padding: 8px;
  }

  &[data-disabled='true'] {
    pointer-events: none;

    * {
      pointer-events: none;
    }
  }
`

export const LoginButtonInner = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`

export const Icon = styled.img`
  border-radius: 100%;
  width: 30px;
  height: 30px;
`

export const Loading = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(1px);
  pointer-events: none;
`